import { PHONE_COUNTRIES } from '../data/phoneCountries';

export function dialDigitsForCountry(code) {
  const c = PHONE_COUNTRIES.find((x) => x.code === code);
  return String((c && c.dial) || '+51').replace(/\D/g, '');
}

export function buildInternationalPhone(countryCode, local) {
  const cc = dialDigitsForCountry(countryCode);
  const localDigits = String(local || '').replace(/\D/g, '');
  if (!localDigits) return '';
  return `+${cc}${localDigits}`;
}

/** Separa un teléfono guardado (+51987654321) en país y número local. */
export function parseInternationalPhone(phone) {
  const empty = { countryCode: 'PE', local: '' };
  const raw = String(phone || '').trim();
  if (!raw) return empty;

  const digits = raw.replace(/\D/g, '');
  if (!digits) return empty;

  const byDialLen = [...PHONE_COUNTRIES].sort(
    (a, b) => b.dial.replace(/\D/g, '').length - a.dial.replace(/\D/g, '').length
  );

  for (const c of byDialLen) {
    const cc = c.dial.replace(/\D/g, '');
    if (cc && digits.startsWith(cc) && digits.length > cc.length) {
      return { countryCode: c.code, local: digits.slice(cc.length) };
    }
  }

  if (raw.startsWith('+')) {
    return empty;
  }

  return { countryCode: 'PE', local: digits };
}

export function validatePhoneLocal(countryCode, local) {
  const cc = dialDigitsForCountry(countryCode);
  const localDigits = String(local || '').replace(/\D/g, '');
  const allDigits = cc + localDigits;
  if (!localDigits) {
    return { ok: false, reason: 'empty' };
  }
  if (localDigits.length < 6) {
    return { ok: false, reason: 'short' };
  }
  if (allDigits.length < 8 || allDigits.length > 15) {
    return { ok: false, reason: 'invalid' };
  }
  return { ok: true, phone: buildInternationalPhone(countryCode, localDigits) };
}
